import api from './api';
import { Sale, SaleType, PaymentMethod, SaleStatus } from '@/types';

export interface SaleItemCreate {
  product_id?: number;  // Opcional para items personalizados
  custom_name?: string; // Nombre para items sin producto
  patient_id?: number;
  quantity?: number;
  unit_price?: number;
  ml_quantity?: number; // Cantidad en ml para productos sell_by_ml
  discount_percentage?: number;
  discount_amount?: number;
  notes?: string;
  applied_in_consultation?: boolean;
}

export interface SaleCreate {
  sale_type?: SaleType;
  owner_id?: number;
  items: SaleItemCreate[];
  discount_percentage?: number;
  discount_amount?: number;
  rounding_adjustment?: number;  // Ajuste por redondeo en efectivo (+/-)
  payment_method?: PaymentMethod;
  payment_reference?: string;
  card_type?: 'debit' | 'credit';
  card_installments?: number;
  // Pago dividido: cuanto entro por cada medio. Tienen que sumar el total de la venta.
  is_split?: boolean;
  amount_cash?: number;
  amount_card?: number;
  amount_transfer?: number;
  notes?: string;
  create_medical_record?: boolean;
  medical_record_data?: {
    reason?: string;
    symptoms?: string;
    diagnosis?: string;
    treatment?: string;
    prescription?: string;
    weight?: number;
    temperature?: number;
    next_visit_date?: string;
    next_visit_reason?: string;
    notes?: string;
  };
}

export interface SaleFilters {
  owner_id?: number;
  sale_type?: SaleType;
  sale_status?: SaleStatus;
  payment_method?: PaymentMethod;
  date_from?: string;
  date_to?: string;
  skip?: number;
  limit?: number;
}

export const salesService = {
  async getSales(filters?: SaleFilters): Promise<Sale[]> {
    const response = await api.get<Sale[]>('/sales', { params: filters });
    return response.data;
  },

  async getSale(id: number): Promise<Sale> {
    const response = await api.get<Sale>(`/sales/${id}`);
    return response.data;
  },

  async createSale(data: SaleCreate): Promise<Sale> {
    const response = await api.post<Sale>('/sales', data);
    return response.data;
  },

  async cancelSale(id: number): Promise<Sale> {
    const response = await api.post<Sale>(`/sales/${id}/cancel`);
    return response.data;
  },

  async getSalesByPatient(patientId: number): Promise<Sale[]> {
    const response = await api.get<Sale[]>(`/sales/patient/${patientId}`);
    return response.data;
  },
};
